exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.show-discount {\n\tfont-weight: 600;\n\tpadding-top: 3px;\n\tfont-size: 12.2px;\n}\n", ""]);

// exports
